import { Divider, Flex, Stack } from '@mantine/core';
import { useFocusTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setFocusMode } from '../../../../../store/strategy-store/strategy-store.actions';
import { Select } from '../../../../../ui-library/select/select';
import { SmallSquareButton } from '../../../../financials/charts/shared/small-square-button';
import { FocusMode } from '../../initiative-performance.type';
import { FiltersBoards } from './filters-boards';
import { FiltersTeams } from './filters-teams';
import { getFocusModeOptions } from './filters.helpers';

export const Filters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const focusMode = useFocusTabStore((state) => state.mode);

  const focusModeOptions = getFocusModeOptions();

  return (
    <Stack gap="md" h="100%">
      <Flex justify="space-between" align="center" w="100%">
        <Select options={focusModeOptions} value={focusMode} onChange={(value) => setFocusMode(value as FocusMode)} />
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Flex>
      <Divider />
      {focusMode === FocusMode.ContributingTeams && <FiltersTeams />}
      {focusMode === FocusMode.ContributingBoards && <FiltersBoards />}
    </Stack>
  );
};
